module.exports = __webpack_public_path__ + "static/media/view test info.f89f05e1.svg";